import React from 'react';
import { motion } from 'framer-motion';
import { Send, Globe, ArrowRight } from 'lucide-react';
export function BookingCTA() {
  return <section id="contact" className="py-24 bg-[#1a1a2e] relative overflow-hidden" data-id="element-38">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#c9a96e] rounded-full mix-blend-overlay filter blur-3xl opacity-10 transform translate-x-1/2 -translate-y-1/2" data-id="element-39" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#8b2252] rounded-full mix-blend-overlay filter blur-3xl opacity-10 transform -translate-x-1/2 translate-y-1/2" data-id="element-40" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-43">
            立即预约您的<span className="text-[#c9a96e]" data-id="element-44">专属体验</span>
          </h2>
          <p className="text-xl text-gray-300 mb-4 font-light" data-id="element-45">
            Book Your Exclusive Experience Now
          </p>
          <p className="max-w-2xl mx-auto text-gray-400 leading-relaxed mb-10" data-id="element-46">
            通过Telegram或官网即可轻松预约新加坡幸福缘的专业按摩与伴游服务。我们提供24小时在线预约，支持上门按摩、酒店按摩等多种服务方式，专业客服团队随时为您解答疑问，确保您享受最便捷、最贴心的预约体验。
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-47">
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#0088cc] text-white rounded-sm hover:bg-[#0077b5] transition-all duration-300 shadow-lg shadow-blue-900/20" data-id="element-48">
              <Send size={20} data-id="element-49" />
              <span className="font-semibold" data-id="element-50">Telegram 预约</span>
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-51" />
            </a>

            <a href="https://www.geylang777-5.site" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-3 px-8 py-4 bg-[#c9a96e] text-[#1a1a2e] rounded-sm hover:bg-[#d4af37] transition-all duration-300 shadow-lg shadow-yellow-900/20" data-id="element-52">
              <Globe size={20} data-id="element-53" />
              <span className="font-semibold" data-id="element-54">访问官网</span>
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-55" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}